module.exports = __webpack_public_path__ + "static/img/y24-2.5e23a32.png";


//////////////////
// WEBPACK FOOTER
// ./src/view/images/y24-2.png
// module id = T1wa
// module chunks = 1